import React from 'react';

import { ngettext, gettext } from '@eb/i18n';
import { Icon } from '@eb/eds-icon';
import { UserChunky } from '@eb/eds-iconography';

/**
 * @name getSignal
 * @param {obj} signal object representing signal to be displayed in event cards
 * @note At the moment this is assuming only a follower count signal
 * more may be added at which point we can convert to a map
 */
const getSignal = (signal) => {
    const signalDisplayValue = getSignalDisplayValue(signal.value);

    //Translators: 1 follower
    //Translators: 2 followers
    const content = ngettext(
        '%(followCount)s follower',
        '%(followCount)s followers',
        signal.value,
        {
            followCount: signalDisplayValue,
        },
    );

    return (
        <div
            data-subcontent-key="follow"
            className="eds-event-card__sub-content--signal eds-text-color--ui-800 eds-text-weight--heavy"
        >
            <Icon type={<UserChunky />} size="xsmall" />
            <span className="eds-l-pad-hor-1" />
            {content}
        </div>
    );
};

/**
 * @name getSignalDisplayValue
 * @param {num} value numeric signal value
 * @returns formatted string representation of numeric signal param
 */
export const getSignalDisplayValue = (value) => {
    if (value < 1000) {
        return `${value}`;
    }

    //returns: 2.8k
    return `${(value / 1000).toFixed(1)}k`.replace('.0', '');
};

/**
 * @name getOrganizerNameNode
 * @param {string} organizerName string representation of event organizer name
 * @returns event organizer component
 */
const getOrganizerNameNode = (organizerName) => {
    let component;

    if (organizerName) {
        component = (
            <div
                data-subcontent-key="organizerName"
                className="eds-event-card__sub-content--organizer eds-text-color--ui-800 eds-text-weight--medium card-text--truncated__two"
            >
                {organizerName}
            </div>
        );
    }

    return component;
};

/**
 * @name SignalContent
 * @param {*} signal
 * @param {*} organizerName
 * @returns
 */
export const SignalContent = (signal, organizerName) => {
    return (
        <div data-subcontent-key="signal">
            {signal?.type === 'follow'
                ? getOrganizerNameNode(organizerName)
                : null}
            {getSignal(signal)}
        </div>
    );
};
